// emrBridge.js
// EMR access for the agent, runtime-registered like recorderBridge so the
// same code bundles in BOTH surfaces:
// - Web app: the MockEMR adapter below (default) — push/schedule resolve
//   with canned success so flows are exercisable without an EMR.
// - Chrome extension: the extension can register a real adapter backed by
//   EMR_Integration/react_webInjector.ts (getScheduleFromEMR,
//   answerQuestionsInEMR, getHaveInjector...) at startup. TODO: wire in
//   extension src/index.js once the injector push flow is agent-ready.
import { Emitter } from './events';

const events = new Emitter();
let adapter = null;

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const mockEMRAdapter = {
  name: 'MockEMR',
  isMock: true,
  /** Pretend to push a finished note into the EMR. */
  async pushNote(conversationId, patientName) {
    await delay(2500); // visible working -> resolved transition
    console.info(`MockEMR: pushed note for ${patientName} (${conversationId})`);
    return { ok: true, mock: true };
  },
  async getSchedule() {
    return { ok: false, error: 'Mock EMR has no schedule source' };
  },
  async getPatientInfo() {
    return null;
  },
};

export const registerEMRAdapter = (a) => {
  adapter = a || mockEMRAdapter;
  events.emit('adapter', adapter.name);
  return () => {
    if (adapter === a) adapter = mockEMRAdapter;
  };
};

export const onEMRAdapterChange = (cb) => events.on('adapter', cb);
export const getEMRAdapter = () => adapter;
export const emrIsMock = () => Boolean(adapter?.isMock);

// Default: mock, so the web app (and the extension until it registers the
// injector adapter) always has a working EMR surface.
registerEMRAdapter(mockEMRAdapter);
